
import { useSelector } from 'react-redux';

import { RootState } from '@share/utils';

export function ApplicationGoogleManager() {

  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { account } = loginStore;
  
  const googleTagManagerCode = account?.googleTagManagerCode;

  if (!googleTagManagerCode) {
    return null;
  }

  return (
    <>
        <iframe src={`https://www.googletagmanager.com/ns.html?id=${googleTagManagerCode}`}
        height="0" width="0" style={{ display: 'none', visibility: 'hidden' }}>
        </iframe>
    </>);
}
